import { render, staticRenderFns } from "./BaseMessage.vue?vue&type=template&id=5a4af603"
import script from "./BaseMessage.vue?vue&type=script&lang=js"
export * from "./BaseMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a4af603')) {
      api.createRecord('5a4af603', component.options)
    } else {
      api.reload('5a4af603', component.options)
    }
    module.hot.accept("./BaseMessage.vue?vue&type=template&id=5a4af603", function () {
      api.rerender('5a4af603', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseMessage.vue"
export default component.exports